export default __webpack_public_path__ + "static/4-033cb487d807c2e61b3ddcc5d7875952.png";